import React, { FC } from 'react';
import { TypeTextCtaFields } from '@/core/generated-types';

const TextCta: FC<TypeTextCtaFields> = ({ title, subtitle }) => {
  return (
    <div className="px-8 py-16">
      <div className="mx-auto max-w-[740px] text-center">
        <div
          className="text-[32px] font-bold leading-[40px] md:text-[42px] md:leading-[56px]"
          data-testid="title"
        >
          {title}
        </div>
        {subtitle && (
          <div className="mt-4 text-lg" data-testid="subtitle">
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(TextCta);
